import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Beaver0 from "./assets/beaver0.svg";
import Beaver00 from "./assets/beaver00.svg";
import Beaver1 from "./assets/beaver1.svg";
import Beaver2 from "./assets/beaver2.svg";
import Beaver3 from "./assets/beaver3.svg";
import Beaver4 from "./assets/beaver4.svg";
import Beaver5 from "./assets/beaver5.svg";
import Beaver6 from "./assets/beaver6.svg";
import Beaver7 from "./assets/beaver7.svg";
import Beaver8 from "./assets/beaver8.svg";
import Beaver9 from "./assets/beaver9.svg";
import Beaver10 from "./assets/beaver10.svg";
import Beaver11 from "./assets/beaver11.svg";
import Beaver12 from "./assets/beaver12.svg";
import Beaver13 from "./assets/beaver13.svg";
import Beaver14 from "./assets/beaver14.svg";
import Beaver15 from "./assets/beaver15.svg";
import Beaver16 from "./assets/beaver16.svg";
import Beaver17 from "./assets/beaver17.svg";
import Beaver18 from "./assets/beaver18.svg";

import "./App.css";

const BookStylePage = () => {
  const [currentPage, setCurrentPage] = useState(0);

  // Easy to edit: Add more pages here
  const pages = [
    {
      text: "Biba Little Story",
      image: Beaver0,
      bgColor: "#ffffff",
      isCover: true, // This marks it as a cover page
    },
    {
      text: "Once upon a time, there was a beaver who felt lonely and a little sad, so he decided to travel and change his life.",
      image: Beaver1,
      bgColor: "#ffffff",
    },
    {
      text: "He landed in Taiwan, climbed Elephant Mountain, and for the first time in a while, the beaver felt truly happy.",
      image: Beaver2,
      bgColor: "#ffffff",
    },
    {
      text: "He fell in love with bubble tea, ate snacks every night, and enjoyed every small moment.",
      image: Beaver3,
      bgColor: "#ffffff",
    },
    {
      text: "But everything tasted better and felt brighter when the beaver met a beaver lady — riding bikes together and walking through night markets side by side.",
      image: Beaver4,
      bgColor: "#ffffff",
    },
    {
      text: "The premium sweet potato balls became his favorite, especially because he could always share them with you.",
      image: Beaver5,
      bgColor: "#ffffff",
    },
    {
      text: "On hot days and quiet evenings, he loved bullying turtles with you and laughing together without a care.",
      image: Beaver6,
      bgColor: "#ffffff",
    },
    {
      text: "And his heart felt completely full when, together, you stopped to help a little bird.",
      image: Beaver7,
      bgColor: "#ffffff",
    },
    {
      text: "He loved the night adventures most of all — painting beaver graffiti and leaving small pieces of love everywhere, just for you.",
      image: Beaver8,
      bgColor: "#ffffff",
    },
    {
      text: "And he was happiest because you always gave him space to do skateboardoo — cheering him on as he made new friends and found even more joy.",
      image: Beaver9,
      bgColor: "#ffffff",
    },
    {
      text: "The beavers loved having little surprises every day, opening duckoo mystery boxes and never knowing what small adventure would come next.",
      image: Beaver10,
      bgColor: "#ffffff",
    },
    {
      text: "Even searching at night for cadoo felt like a new adventure, because somehow we would always end up with fresh brown sugar bao in our hands.",
      image: Beaver11,
      bgColor: "#ffffff",
    },
    {
      text: "All the memories still feel alive, like they happened yesterday — little treasures waiting for us to revisit them again.",
      image: Beaver12,
      bgColor: "#ffffff",
    },
    {
      text: "And it wasn’t only the happy moments that mattered. Even the sad ones — like when I was sick — you stayed beside me and made me feel safe and deeply loved.",
      image: Beaver13,
      bgColor: "#ffffff",
    },
    {
      text: "Even in the quietest evenings, watching the sunset alone in Tamsui, I could still smile, because I knew how lucky I was to have lived those moments with you.",
      image: Beaver14,
      bgColor: "#ffffff",
    },
    {
      text: "There were also days when I felt lonely in a foreign country, far away from you, eating ramen every day just to fill the emptiness in my stomach and my heart.",
      image: Beaver15,
      bgColor: "#ffffff",
    },
    {
      text: "I would think, ‘I wish I had more time with you. I wish we had done even more together.’ I never knew how deeply I would feel your absence until you weren’t there.",
      image: Beaver16,
      bgColor: "#ffffff",
    },
    {
      text: "But every happy and sad moment shaped us into who we are. I will never regret any of it. They will always live in my heart, no matter where you are or where life takes you.",
      image: Beaver17,
      bgColor: "#ffffff",
    },
    {
      text: "But the story is not finished. We don’t know what tomorrow brings. Until the day we meet again, be happy, feel loved, and live fully — for yourself and for me.",
      image: Beaver18,
      bgColor: "#ffffff",
    },
    {
      text: "Not The End",
      image: Beaver00,
      bgColor: "#ffffff",
      isCover: true, // This marks it as a cover page
    },
  ];

  const nextPage = () => {
    if (currentPage < pages.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const currentSlide = pages[currentPage];

  return (
    <>
      <div
        className="book-container"
        style={{ backgroundColor: currentSlide.bgColor }}
      >
        {/* Main Content */}
        {currentSlide.isCover ? (
          // Cover Page Layout - Full image with centered text
          <div className="cover-wrapper">
            <img src={currentSlide.image} alt="Cover" className="cover-image" />
            <div className="cover-overlay"></div>
            <h1 className="cover-text">{currentSlide.text}</h1>
          </div>
        ) : (
          // Regular Page Layout - Split layout
          <div className="content-wrapper">
            {/* Left Side - Text (30%) */}
            <div className="text-section">
              <h1 className="story-text">{currentSlide.text}</h1>
            </div>

            {/* Right Side - Image (70%) */}
            <div className="image-section">
              <img
                src={currentSlide.image}
                alt={`Slide ${currentPage + 1}`}
                className="main-image"
              />
              <div className="image-overlay"></div>
            </div>
          </div>
        )}

        {/* Navigation */}
        <div className="navigation">
          {/* Previous Button */}
          <button
            onClick={prevPage}
            disabled={currentPage === 0}
            className="nav-button"
          >
            <ChevronLeft size={24} />
          </button>

          {/* Page Indicators */}
          <div className="page-indicators">
            {pages.map((_, index) => (
              <div
                key={index}
                className={`indicator-dot ${index === currentPage ? "active" : "inactive"}`}
              />
            ))}
          </div>

          {/* Next Button */}
          <button
            onClick={nextPage}
            disabled={currentPage === pages.length - 1}
            className="nav-button"
          >
            <ChevronRight size={24} />
          </button>
        </div>

        {/* Page Counter */}
        <div className="page-counter">
          {currentPage + 1} / {pages.length}
        </div>
      </div>
    </>
  );
};

export default BookStylePage;
